var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-event"},[_c('Button',{attrs:{"type":"secondary","icon":"calendar"},nativeOn:{"click":function($event){return _vm.openCalendar()}}},[_vm._v(" Tambahkan ke kalender ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }